import { render, staticRenderFns } from "./WidgetWorkOrders.vue?vue&type=template&id=03033984"
import script from "./WidgetWorkOrders.vue?vue&type=script&lang=js"
export * from "./WidgetWorkOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports